import React, { useEffect, useRef, useState } from 'react'
import { Button, Form, Modal, Spinner } from 'react-bootstrap'
import { FaWhatsapp } from 'react-icons/fa'
import { SweetAlert } from '../../components/sweetalert'
import Birthdays from '../../services/Birthdays'
import { DEFAULT_WHATSAPP_MESSAGE, fillNames } from '../../utilities/birthdays'
import NameTokenButtons from './NameTokenButtons'
import WhatsappFormatButtons from './WhatsappFormatButtons'
import WhatsappText from './WhatsappText'

const MESSAGE_MAX_LENGTH = 1000

const errorMessage = (error, fallback) => error?.response?.data?.message || error?.message || fallback

const BirthdayWhatsappModal = ({ show, onHide, onSaved }) => {
  const [loading, setLoading] = useState(false)
  const [saving, setSaving] = useState(false)
  const [message, setMessage] = useState('')
  const messageRef = useRef(null)

  useEffect(() => {
    if (!show) return

    setLoading(true)
    Birthdays.findConfig()
      .then(({ data }) => setMessage(data.whatsapp_message || DEFAULT_WHATSAPP_MESSAGE))
      .catch((error) => {
        SweetAlert.error(errorMessage(error, 'Não foi possível carregar a mensagem.'), 'Mensagem do WhatsApp')
        onHide()
      })
      .finally(() => setLoading(false))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [show])

  async function handleSave() {
    if (!message.trim()) return SweetAlert.error('Escreva a mensagem do WhatsApp.', 'Mensagem do WhatsApp')

    setSaving(true)
    try {
      const { data } = await Birthdays.updateConfig({ whatsapp_message: message })
      SweetAlert.success('Mensagem salva com sucesso!', 'Mensagem do WhatsApp')
      onSaved(data.whatsapp_message)
      onHide()
    } catch (error) {
      SweetAlert.error(errorMessage(error, 'Não foi possível salvar a mensagem.'), 'Mensagem do WhatsApp')
    } finally {
      setSaving(false)
    }
  }

  return (
    <Modal show={show} onHide={() => !saving && onHide()} fullscreen='sm-down' scrollable centered>
      <Modal.Header closeButton={!saving}>
        <Modal.Title className='d-flex align-items-center gap-2 fs-5'>
          <FaWhatsapp style={{ color: '#25d366' }} /> Mensagem do WhatsApp
        </Modal.Title>
      </Modal.Header>

      <Modal.Body className='d-flex flex-column gap-3'>
        {loading ?
          <div className='d-flex justify-content-center py-5'><Spinner animation='border' size='sm' /></div>
          :
          <>
            <p className='text-muted m-0' style={{ fontSize: 14 }}>
              Texto que abre no WhatsApp do paciente ao clicar em "Parabenizar". Antes de enviar, dá para conferir e ajustar no próprio WhatsApp.
            </p>

            <Form.Group>
              <Form.Label className='fw-semibold'>Mensagem <span className='text-danger'>*</span></Form.Label>
              <Form.Control
                as='textarea'
                rows={5}
                ref={messageRef}
                value={message}
                maxLength={MESSAGE_MAX_LENGTH}
                disabled={saving}
                onChange={(e) => setMessage(e.target.value)}
              />
              <div className='d-flex align-items-start gap-2 mt-2'>
                <div className='d-flex flex-wrap gap-2 flex-grow-1'>
                  <NameTokenButtons inputRef={messageRef} value={message} onChange={setMessage} disabled={saving} maxLength={MESSAGE_MAX_LENGTH} />
                  <WhatsappFormatButtons inputRef={messageRef} value={message} onChange={setMessage} disabled={saving} maxLength={MESSAGE_MAX_LENGTH} />
                </div>
                <small className='text-muted text-nowrap pt-1'>{message.length}/{MESSAGE_MAX_LENGTH}</small>
              </div>
              <Form.Text as='div' className='d-flex flex-column gap-1 mt-2'>
                <span>Nome do paciente: {'{{primeiro_nome}}'} vira "Maria" e {'{{nome}}'} vira "Maria da Silva".</span>
                <span>
                  Formatação: <span className='birthdays-syntax'>*negrito*</span> <span className='birthdays-syntax'>_itálico_</span>
                  {' '}<span className='birthdays-syntax'>~tachado~</span> <span className='birthdays-syntax'>```monoespaçado```</span>
                  {' '}<span className='birthdays-syntax'>`código`</span>. No começo da linha: <span className='birthdays-syntax'>- </span> lista,
                  {' '}<span className='birthdays-syntax'>1. </span> lista numerada e <span className='birthdays-syntax'>&gt; </span> citação.
                </span>
              </Form.Text>
            </Form.Group>

            <div className='rounded p-3 birthdays-whatsapp-preview'>
              <small className='text-muted fw-semibold d-block mb-2'>Pré-visualização (paciente de exemplo: Maria da Silva)</small>
              <div className='birthdays-whatsapp-bubble'>
                {message.trim() ? <WhatsappText text={fillNames(message.trim())} /> : <span className='fst-italic text-muted'>A mensagem aparecerá aqui.</span>}
              </div>
            </div>
          </>
        }
      </Modal.Body>

      <Modal.Footer>
        <Button variant='outline-secondary' disabled={saving} onClick={onHide}>Cancelar</Button>
        <Button variant='success' className='d-flex align-items-center gap-2' disabled={saving || loading} onClick={handleSave}>
          {saving ? <Spinner animation='border' size='sm' /> : ''} Salvar
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default BirthdayWhatsappModal
